import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import StatsSection from './components/StatsSection';
import ZonesSection from './components/ZonesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { updateMetaTags, addStructuredData, getSiteUrl } from '../../utils/seo';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = getSiteUrl();
    
    updateMetaTags({
      title: 'Vaciado de Pisos El Prat de Llobregat | JUSTCLEAN ELPRAT',
      description: 'Vaciado de pisos y locales en El Prat de Llobregat. Especialistas en limpieza por síndrome de Diógenes y suciedad extrema. Servicio 24h. ☎ 602 36 59 96',
      keywords: 'vaciado de pisos El Prat, limpieza Diógenes, vaciado locales, retirada muebles',
      path: '/',
      ogImage: 'https://public.readdy.ai/ai/img_res/892bd0f9-6539-4d6f-b252-70ffccc85cb2.png'
    });

    // Add LocalBusiness Schema
    const localBusinessSchema = addStructuredData({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "JUSTCLEAN ELPRAT",
      "image": "https://public.readdy.ai/ai/img_res/892bd0f9-6539-4d6f-b252-70ffccc85cb2.png",
      "description": "Especialistas en vaciado de pisos y locales, limpieza por síndrome de Diógenes y suciedad extrema en El Prat de Llobregat",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Carrer de la Verge de Montserrat, 45",
        "addressLocality": "El Prat de Llobregat",
        "addressRegion": "Barcelona",
        "postalCode": "08820",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 41.3275,
        "longitude": 2.0958
      },
      "url": siteUrl,
      "telephone": "+34602365996",
      "email": "info@elprat.justclean.es",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      },
      "areaServed": [
        { "@type": "City", "name": "El Prat de Llobregat" },
        { "@type": "City", "name": "Viladecans" },
        { "@type": "City", "name": "Gavà" },
        { "@type": "City", "name": "Sant Boi de Llobregat" },
        { "@type": "City", "name": "Cornellà de Llobregat" },
        { "@type": "City", "name": "L'Hospitalet de Llobregat" },
        { "@type": "City", "name": "Castelldefels" }
      ],
      "priceRange": "€€",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "127"
      }
    });

    // Add Service Schema
    const serviceSchema = addStructuredData({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Vaciado de Pisos y Locales",
      "provider": {
        "@type": "LocalBusiness",
        "name": "JUSTCLEAN ELPRAT"
      },
      "areaServed": {
        "@type": "City",
        "name": "El Prat de Llobregat"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios de Vaciado y Limpieza",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Pisos y Casas"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vaciado de Locales Comerciales"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Retirada de Muebles y Electrodomésticos"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Limpieza por Síndrome de Diógenes"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pintura Final"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Pequeñas Reparaciones"
            }
          }
        ]
      }
    });

    return () => {
      document.head.removeChild(localBusinessSchema);
      document.head.removeChild(serviceSchema);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <StatsSection />
        <ZonesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
